import { ErrorHandler, inject, Provider } from '@angular/core';
import { ERROR_PROVIDER } from '../services/error.service';

export class LvrGlobalErrorHandler implements ErrorHandler {
	private errorService = inject(ERROR_PROVIDER);
	public handleError(error: unknown) {
		this.errorService.handleError(error, true);
	}
}

export const provideErrorHandler: Provider = {
	provide: ErrorHandler,
	useClass: LvrGlobalErrorHandler,
};
